import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = '/ata-registro-preco/api/public/atas/documentos'

class DocumentosAtaApiClient {
	async baixar(idDocumento) {
		let url = `${URL_PATH}/${idDocumento}/baixar`

		return await axios.get(url, { responseType: 'arraybuffer' })
	}
	async buscarDocumentosPorFiltro(filtro, paginacao, idAta) {
		const url = new SearchUrlParamBuilder({
			urlPath: URL_PATH + `/${idAta}`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}
}

export default new DocumentosAtaApiClient()
